module.exports = __webpack_public_path__ + "assets/img/diploma-100px.b9bbbedb.webp";